import { render, staticRenderFns } from "./IconMonitors.vue?vue&type=template&id=239ff05e"
import script from "./IconMonitors.vue?vue&type=script&lang=ts"
export * from "./IconMonitors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports